const leftItems = [
  'Journals but always skims the surface',
  'Is in therapy and wants more between sessions',
  'Is doing the HOME and wants a physical companion',
  'Has never journaled but knows something needs to shift',
  'Is tired of self-help that does not go deep enough',
];

const rightItems = [
  'Prompts that go where most people are afraid to look',
  'A structured healing journey at her own pace',
  'Space to be completely honest, without performing',
  'A daily practice as little as 5 minutes and as deep as she is willing',
  'The feeling of being guided and held on every page',
];

export default function WhoForSection() {
  return (
    <section className="bg-[#1A1A1A] py-16 md:py-28 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        {/* Eyebrow */}
        <p className="text-[#C9A84C] text-xs font-body tracking-[0.25em] uppercase mb-4 text-center">
          This collection is for her
        </p>

        {/* Headline */}
        <h2 className="font-heading text-xl md:text-3xl lg:text-5xl text-[#FDFAF8] text-center mb-14 leading-tight">
          You do not need to be in therapy to use this. You just need to be ready to be honest.
        </h2>

        {/* Two columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 max-w-5xl mx-auto">
          {/* Left — For the woman who */}
          <div>
            <h3 className="font-heading text-lg text-[#FDFAF8] mb-6">
              For the woman who:
            </h3>
            <ul className="space-y-4">
              {leftItems.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <div className="w-2 h-2 rounded-full bg-[#C9A84C] mt-2 flex-shrink-0" />
                  <span className="font-body text-sm text-[#E8E8E8]">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right — What she will experience */}
          <div>
            <h3 className="font-heading text-lg text-[#FDFAF8] mb-6">
              What she will experience:
            </h3>
            <ul className="space-y-4">
              {rightItems.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <div className="w-2 h-2 rounded-full bg-[#C9A84C] mt-2 flex-shrink-0" />
                  <span className="font-body text-sm text-[#E8E8E8]">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}